import __request__ from "routing/request";
export function get(requestOptions) {
  return __request__("GET", "/streams", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONbody, requestOptions) {
  return __request__("POST", "/streams", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkDelete(Entitiestoremove, requestOptions) {
  return __request__("POST", "/streams/bulk_delete", Entitiestoremove, {}, {
    "Accept": []
  }, requestOptions);
}
export function bulkPause(Streamstopause, requestOptions) {
  return __request__("POST", "/streams/bulk_pause", Streamstopause, {}, {
    "Accept": []
  }, requestOptions);
}
export function bulkResume(Streamstoresume, requestOptions) {
  return __request__("POST", "/streams/bulk_resume", Streamstoresume, {}, {
    "Accept": []
  }, requestOptions);
}
export function getByIndexSet(indexSetId, requestOptions) {
  return __request__("GET", `/streams/byIndex/${indexSetId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getDestinationFilterRuleCountsForStreams(streamIds, requestOptions) {
  return __request__("POST", "/streams/destinations/filters/count", streamIds, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getEnabled(requestOptions) {
  return __request__("GET", "/streams/enabled", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function assignToIndexSet(indexSetId, JSONbody, requestOptions) {
  return __request__("PUT", `/streams/indexSet/${indexSetId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getNoSecurity(requestOptions) {
  return __request__("GET", "/streams/no_security", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPage(sort = "title", page = 1, per_page = 50, query, filters, order = "asc", requestOptions) {
  return __request__("GET", "/streams/paginated", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getConnectedPipelinesForStreams(streamIds, requestOptions) {
  return __request__("POST", "/streams/pipelines", streamIds, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(streamId, JSONbody, requestOptions) {
  return __request__("PUT", `/streams/${streamId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getBystreamId(streamId, requestOptions) {
  return __request__("GET", `/streams/${streamId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(streamId, requestOptions) {
  return __request__("DELETE", `/streams/${streamId}`, null, {}, {
    "Accept": []
  }, requestOptions);
}
export function cloneStream(streamId, JSONbody, requestOptions) {
  return __request__("POST", `/streams/${streamId}/clone`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function pause(streamId, requestOptions) {
  return __request__("POST", `/streams/${streamId}/pause`, null, {}, {
    "Accept": []
  }, requestOptions);
}
export function getConnectedPipelines(streamId, requestOptions) {
  return __request__("GET", `/streams/${streamId}/pipelines`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function resume(streamId, requestOptions) {
  return __request__("POST", `/streams/${streamId}/resume`, null, {}, {
    "Accept": []
  }, requestOptions);
}
export function testMatch(streamId, JSONbody, requestOptions) {
  return __request__("POST", `/streams/${streamId}/testMatch`, JSONbody, {}, {
    "Accept": []
  }, requestOptions);
}
